"use client";

import { createIcon } from "@chakra-ui/react";

const CheckSvgIcon = createIcon({
  displayName: "CheckSvgIcon",
  viewBox: "0 0 24 24",
  path: (
    <path xmlns="http://www.w3.org/2000/svg" d="M12.0003 13.172L16.9503 8.222L18.3643 9.636L12.0003 16L7.63626 11.636L9.05026 10.222L12.0003 13.172Z" fill="currentColor"/>
  ),
});

export default CheckSvgIcon;
